import React from 'react';
import { Button, Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { ConvertCustomerScheduleStatus } from '@/utils/helpers';
import { checkPermission } from '@/utils/permission';

const STATUS_CONFIG = {
    daden: { bgcolor: '#fff176', color: '#000', disabled: false },
    chuaden: { bgcolor: '#ebeaeaff', color: '#000', disabled: false },
    dangcho: { bgcolor: '#fff176', color: '#000', disabled: false },
    dangtrongca: { bgcolor: '#1890ff', color: '#fff', disabled: false },
    daxong: { bgcolor: '#389e0d', color: '#fff', disabled: false },
    dahuy: { bgcolor: '#ff7f50', color: '#fff', disabled: false },
    dagoi: { bgcolor: '#389e0d', color: '#fff', disabled: false },
    chuagoi: { bgcolor: '#ebeaeaff', color: '#000', disabled: false },
    dachuyenlich: { bgcolor: '#c5c5c5', color: '#fff', disabled: true },
};

const ScheduleStatusButton = ({ record, onClick }) => {
    const text = record.status;

    const { bgcolor = '', color = '#fff', disabled: statusDisabled = false } =
        STATUS_CONFIG[text] || {};

    const hasPermission = checkPermission('customer_schedule', 'update_status');

    const isViewOnly = !onClick;

    // Disabled logic chỉ ảnh hưởng click, không ảnh hưởng màu
    const finalDisabled = isViewOnly || !hasPermission || statusDisabled;

    const content = (
        <Button
            disabled={finalDisabled}
            icon={
                (!finalDisabled && hasPermission && !statusDisabled)
                    ? <EditOutlined />
                    : undefined
            }
            style={{
                background: bgcolor,    // luôn giữ nguyên màu config
                color: color,            // luôn giữ nguyên màu config
                border: 'none',
                width: '100%',
                opacity: finalDisabled ? 1 : 1, // không làm mờ để tránh đổi màu
            }}
            size="small"
            onClick={() => {
                if (!finalDisabled && onClick) onClick(record);
            }}
        >
            {ConvertCustomerScheduleStatus(text, true)}
        </Button>
    );

    // Trường hợp không click / không permission → không hiển thị tooltip
    if (finalDisabled) return content;

    return (
        <Tooltip title="Click để cập nhật" placement="right">
            {content}
        </Tooltip>
    );
};

export default ScheduleStatusButton;